import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/faq/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/learn/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/review/review.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/senet/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/solved/hero.png");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/finkel.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/victor_board.jpg");
